import React from 'react';
import { Field } from 'redux-form';
import { getName, doesValueMatchPersonData } from 'common/personUtils';
import { useIntl } from 'react-intl';
import InputTagsSuggest from '../../containers/InputTagsSuggest';

const OrderingProviderSearchField = ({
  placeholder,
  className,
  autocompleteData,
  styles = {},
  defaultValue = '',
  onRemoveTag = undefined,
}) => {
  const intl = useIntl();
  return (
    <div className={className || styles.orderingProviderField}>
      <Field
        name="providers"
        component={InputTagsSuggest}
        placeholder={
          placeholder ||
          intl.formatMessage({
            id: 'search.SearchForm.ProviderField.PlaceHolder',
          })
        }
        suggestions={autocompleteData}
        getSuggestionValue={d => {
          return getName(d.firstName, d.lastName, '');
        }}
        renderSuggestion={d => (
          <div className={styles.autoSuggestSelectOption}>
            <p className={styles.autoSuggestSelectOptionPrimary}>
              {getName(d.firstName, d.lastName, '')}
            </p>
          </div>
        )}
        filterSuggestion={(inputValue, suggestions) => {
          return suggestions.filter(patient =>
            doesValueMatchPersonData(patient, inputValue),
          );
        }}
        defaultValue={defaultValue}
        onRemoveTag={inputValue => {
          onRemoveTag('providers', inputValue);
        }}
      />
    </div>
  );
};
export default OrderingProviderSearchField;



// WEBPACK FOOTER //
// ./src/views/components/Search/OrderingProviderSearchField.jsx